import PropTypes from "prop-types";
import { paths } from "../../routes/paths";
import { convertToTitleCase, getDateWithFormat } from "../../utils/commons";
import NoResultsFound from "../common/table/NoResultsFound";
import Table from "../common/table/Table";
import "./performancesTable.scss";
import { getEngagementTypeSpecificTableData } from "./utils";

const PerformancesTable = ({
  performancesData,
  currentProgramTimezone,
  engagementType,
  onTap = () => {},
  onResetAllFilters = () => {},
  onChangeFilters = () => {},
  tableConfig,
}) => {
  const handleClick = (e, item) => {
    e.preventDefault();
    onTap(item);
  };

  const rowData = performancesData.map((item) => {
    const engagementID = item.id || "-";
    const compositeStatus = item.status || "-";
    const compositeStatusClass = compositeStatus.toLowerCase().replace("_", "-");
    return {
      id: (
        <a
          className="performances-widget-id"
          href={`${paths.performances_list}/${paths.performance_details}/${engagementID}`}
          rel="noopener noreferrer"
          onClick={(e) => handleClick(e, item)}
        >
          {engagementID}
        </a>
      ),
      identifier: item.identifier || "-",
      user: item.profileEmail || "-",
      profileId: item.profileId || "-",
      channel: item.channel || "-",
      startDate: item.performanceDate
        ? getDateWithFormat(item.performanceDate, currentProgramTimezone)
        : "-",
      campaign: item.campaignName || "-",
      outcomeName:
        item.outcomes
          ?.map((outcome) => convertToTitleCase(outcome.outcome))
          .join(", ") || "-",
      outcomeQuantity:
        item.outcomes?.map((outcome) => outcome.value ?? "N/A").join(", ") || "-",
      activityType: item.engagementType ?? "-",
      status: (
        <span className={`performances-lifecycle-status ${compositeStatusClass}`}>
          {compositeStatus}
        </span>
      ),
    };
  });

  const typeSpecificTableData =
    engagementType &&
    getEngagementTypeSpecificTableData(
      engagementType,
      performancesData,
      handleClick,
      currentProgramTimezone
    );

  const tableHeaders = tableConfig?.headerData || typeSpecificTableData?.headerData;

  return (
    <div className="performances-container">
      <div className="performances-list-container">
        <Table
          headerData={tableHeaders}
          rowData={typeSpecificTableData?.rowData || rowData}
          className="performances-list-table"
          noResultsFound={
            <NoResultsFound
              onChangeFilters={onChangeFilters}
              onResetAllFilters={onResetAllFilters}
            />
          }
        />
      </div>
    </div>
  );
};

PerformancesTable.propTypes = {
  performancesData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      profileEmail: PropTypes.string,
      performanceDate: PropTypes.string,
      campaignName: PropTypes.string,
      outcomes: PropTypes.arrayOf(
        PropTypes.shape({
          outcome: PropTypes.string,
          value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
            PropTypes.oneOf([null]),
          ]),
        })
      ),
      engagementType: PropTypes.string,
      status: PropTypes.string,
    })
  ).isRequired,
  currentProgramTimezone: PropTypes.string.isRequired,
  engagementType: PropTypes.string,
  onTap: PropTypes.func,
};

export default PerformancesTable;
